import { createSlice, createAction } from '@reduxjs/toolkit';

export const fetchEntitlementsRequest = createAction('entitlements/fetchEntitlementsRequest');

const initialState = {
    entitlements: [],
    loading: false,
    error: null,
};

const entitlementsSlice = createSlice({
    name: 'entitlements',
    initialState,
    reducers: {
        fetchEntitlementsStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchEntitlementsSuccess: (state, action) => {
            state.loading = false;
            state.entitlements = action.payload || [];
            state.error = null;
        },
        fetchEntitlementsFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        clearEntitlements: (state) => {
            state.entitlements = [];
            state.loading = false;
            state.error = null;
        },
    },
});

export const {
    fetchEntitlementsStart,
    fetchEntitlementsSuccess,
    fetchEntitlementsFailure,
    clearEntitlements,
} = entitlementsSlice.actions;

export default entitlementsSlice.reducer;
